// extracted by mini-css-extract-plugin
export default {"home":"Home_home__uEIM2","wrapper":"Home_wrapper__IA6WD","left":"Home_left__6bE0c","right":"Home_right__GCaNv"};